import React from 'react';
import { container } from './header.module.css';
export const Header = (props: { children: React.ReactNode }) => {
  return <h1 className={container}>{props.children}</h1>;
};
